module.exports = __webpack_public_path__ + "static/media/Paediatric-Camp-web.8549bef7.jpg";